export const listingNavigationButtonSx = (published: boolean) => ({
  width: 260, maxWidth: '100%', whiteSpace: 'nowrap',
  backgroundColor: published ? '#f2d675' : '#eeeae3', color: '#241c05',
  borderColor: published ? '#f2d675' : '#eeeae3', boxShadow: 'none',
  '&:hover': { backgroundColor: published ? '#f5df96' : '#e2dcd2', borderColor: published ? '#f5df96' : '#e2dcd2', boxShadow: 'none' }
});
